<template>
    <div class="pageContent">
        <div class="pagebox">
            <span v-if="this.current > 2" @click="goToPage(1)">首页</span>
            <span v-if="info.previous" @click="goToPage(prePage)">上一页</span>
            <p>{{ this.current }}&nbsp;/&nbsp;{{ showLastPage }}</p>
            <span v-if="info.next"  @click="goToPage(nextPage)">下一页</span>
            <span v-if="this.current < lastPage - 1" @click="goToPage(lastPage)">末页</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page',
    props: ['info'],
    data: function() {
        return {
            current: 1
        }
    },        
    computed: {
        showLastPage(){
            return this.lastPage < 100 ? this.lastPage : '100...'
        },
        lastPage() {      
            if (!this.info || !this.info.count) return 1;   
            let pageSize = 42;
            return Math.ceil(this.info.count / pageSize);
        },
        prePage() {
            if (this.current > 1) {
                return this.current - 1;
            }
            return 1;
        },
        nextPage() {
            if (this.current < this.lastPage) {
                return this.current + 1;
            }
            return this.current;
        }
    },
    mounted() {
        this.current = this.getPageFromUrl();
    },
    methods: {
        getPageFromUrl() {
            const page = Number(this.$route.query.page);
            return page ? page : 1;
        },
        goToPage(page) {
            this.current = page;
            const params = {...this.$route.query};
            params.page = page;
            this.$router.push({ query: params })
        }
    },
    watch: {
        '$route'(to, from) {
            this.current = this.getPageFromUrl();
        }
    }
}
</script>

<style>

.pageContent{
  display: flex;
  width: 1280px;
  margin: 0 auto;
}

.pagebox{
    margin-top: 2px;
    margin-left: auto;
}

.pagebox p{
    margin: 0px 2px;
    float: left;
    text-align: center;
    text-decoration: none;
    color: gray;
    text-align: center;
    line-height: 24px;
}

.pagebox span{
    cursor: pointer;
    padding: 0px 12px;
    height: 24px;
    font-size: 14px;
    float: left;
    text-align: center;
    text-decoration: none;
    color: gray;
    text-align: center;
    line-height: 24px;
}

.pagebox span:hover{
    color: #45B5B5;
    font-weight:600;
}

</style>